export const PERMISSION_CREATE_TX_BATCH = 'fin-transaction-batch-create';
